import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicationForUser } from '../../../models/borrower-portal/application-for-user-model';
import { ApplicationTaskModel } from '../../../models/borrower-portal/application-task-model';

@Component({
    selector: 'tasks-assets',
    templateUrl: './tasks-assets.component.html',
    styleUrls: ['./tasks-assets.component.scss'],
    standalone: false
})
export class TasksAssetsComponent implements OnInit {

  @Input() tasks: ApplicationTaskModel[] = [];
  @Input() application: ApplicationForUser;

  @Input() showAssetsButton: boolean = true;
  @Input() isSubmitted: boolean;
  
  @Output() openAssetsClicked = new EventEmitter<ApplicationTaskModel>();

  /** Tracks which task cards are expanded on mobile */
  protected expandedTaskIds = new Set<number>();

  constructor() { }

  ngOnInit(): void {
  }

  toggleTaskExpanded(taskId: number): void {
    if (this.expandedTaskIds.has(taskId)) {
      this.expandedTaskIds.delete(taskId);
    } else {
      this.expandedTaskIds.add(taskId);
    }
  }

  isTaskExpanded(taskId: number): boolean {
    return this.expandedTaskIds.has(taskId);
  }

  openAssetsModal = (task: ApplicationTaskModel) => {
    this.openAssetsClicked.emit(task);
  }
}
